import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function FormDateField({
  fieldname,
  control,
  label,
  rules,
  required = false,
}) {
  // Merge required rule if `required` prop is true
  const combinedRules = required
    ? { ...rules, required: `This field is required` }
    : rules;

  return (
    <Controller
      name={fieldname}
      control={control}
      rules={combinedRules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box>
          <Typography variant="body1" textAlign={"left"}>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              // label={label}
              value={value ? dayjs(value, "DD/MM/YYYY") : null}
              onChange={(date) => {
                onChange(date ? date.format("DD/MM/YYYY") : "");
              }}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  error: !!error,
                  helperText: error ? error.message : null,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      )}
    />

    // <Controller
    //   defaultValue={""}
    //   name={fieldname}
    //   control={control}
    //   rules={combinedRules}
    //   render={({
    //     field: { onChange, value },
    //     fieldState: { error },
    //     formState,
    //   }) => (
    //     <Box>
    //       <Typography variant="body1" textAlign={"left"}>
    //         {label} {required && <span style={{ color: "red" }}>*</span>}
    //       </Typography>
    //       <TextField
    //         fullWidth
    //         helperText={error ? error.message : null}
    //         error={!!error}
    //         onChange={onChange}
    //         value={value}
    //         InputLabelProps={{
    //           shrink: true,
    //         }}
    //         type={"date"}
    //         size="small"
    //         // label={label && label}
    //         variant="outlined"
    //         sx={{
    //           "& input": {
    //             color: value ? "black" : "gray", // Set the color based on value
    //           },
    //         }}
    //       />
    //     </Box>
    //   )}
    // />
  );
}
